import React, { useContext, useState } from "react";
import { Formik } from "formik";
import { Form, Modal, Button } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import {
  faPencilAlt,
  faTimes,
  faTrashAlt,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  managePlanFormNames,
  formFields,
  transformToMultiselectSave,
  SOURCE_CATEGORY_NAME_MAPPING,
  synchronizeCollection,
  getAdvancedPathWithParam,
} from "../../../utils";
import { getValidation } from "../../../services";
import { ManagePlanLayout, DeleteWarning } from "../../../components";
import { useRouterParams } from "../../../abstracts";
import EmployeeAdditionalAllocationRulesForm from "./EmployeeAdditionalAllocationRulesForm";
import EmployerAdditionalAllocationRulesForm from "./EmployerAdditionalAllocationRulesForm";
import {
  createPlanStore,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
} from "../../../contexts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SourcesAdditonalAllocationRulesContainer = (props) => {
  const { state, dispatch } = useContext(createPlanStore);
  const { history } = props;
  const { flow, planId, sourceId, ruleId } = useRouterParams();
  const [newFlow, setNewFlow] = useState(flow);
  const intSourceId = parseInt(sourceId);
  const intRuleId = parseInt(ruleId);
  const formName = managePlanFormNames.SOURCES_ADDITIONAL_RULES;
  const fields = formFields[formName];
  const sourcesListData = get(state, "sources", []);
  const sourcesFormValues = sourcesListData;
  const sourceCategory = get(sourcesFormValues, "sourceCategory", 0);
  const isDeferral = sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Deferral;
  const isEmployerDiscretionary =
    sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Discretionary;
  const isEmployerMatch = sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.Match;
  const [showWarning, setShowWarning] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const employeeDeferralSource = get(
    sourcesFormValues,
    "employeeDeferralSource",
    {}
  );
  const employerMatchSource = get(sourcesFormValues, "employerMatchSource", {});
  const DeleteToastMessage =
    "You are attempting to delete additional allocation rule.";
  const DeleteToastMessageHead = "Delete Additional Allocation Rules?";

  const employerDiscretionarySource = get(
    sourcesFormValues,
    "employerDiscretionarySource",
    {}
  );
  var additionalAllocationRulesData = isDeferral
    ? get(employeeDeferralSource, "additionalDeferralSource", [])
    : isEmployerMatch
    ? get(employerMatchSource, "additionalMatchSources", [])
    : isEmployerDiscretionary
    ? get(employerDiscretionarySource, "additionalDiscretionarySources", [])
    : [];

  additionalAllocationRulesData =
    additionalAllocationRulesData === null ? [] : additionalAllocationRulesData;
  const formValues = get(additionalAllocationRulesData, intRuleId, {});

  const goBack = () => {
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
        pathParam: [flow, planId, sourceId],
      })
    );
  };
  const onDeleteClick = () => {
    setShowWarning(true);
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const handleClose = () => {
    setShowPopup(false);
  };
  const sourcesWithId = get(state, "api.data.sources", []);
  var sourceAllocation = isDeferral
    ? get(
        sourcesWithId[sourceId]?.employeeDeferralSource,
        "additionalDeferralSource",
        []
      )
    : isEmployerMatch
    ? get(
        sourcesWithId[sourceId]?.employerMatchSource,
        "additionalMatchSources",
        []
      )
    : isEmployerDiscretionary
    ? get(
        sourcesWithId[sourceId]?.employerDiscretionarySource,
        "additionalDiscretionarySources",
        []
      )
    : [];
  const handleConfirmClick = () => {
    setShowWarning(false);
    const data = {
      id: sourceAllocation[ruleId]?.id,
      typeId: sourcesWithId[sourceId]?.sourceCategory,
    };

    const updatedSourceFormValues = {
      ...sourcesFormValues,
      employeeDeferralSource: isDeferral
        ? {
            ...employeeDeferralSource,
            additionalDeferralSource: additionalAllocationRulesData.map(
              (item, index) => {
                if (index == intRuleId) {
                  return { ...item, isDeleted: true };
                }
                return item;
              }
            ),
          }
        : employeeDeferralSource,
      employerMatchSource: isEmployerMatch
        ? {
            ...employerMatchSource,
            additionalMatchSources: additionalAllocationRulesData.map(
              (item, index) => {
                if (index == intRuleId) {
                  return { ...item, isDeleted: true };
                }
                return item;
              }
            ),
          }
        : employerMatchSource,
      employerDiscretionarySource: isEmployerDiscretionary
        ? {
            ...employerDiscretionarySource,
            additionalDiscretionarySources: additionalAllocationRulesData.map(
              (item, index) => {
                if (index == intRuleId) {
                  return { ...item, isDeleted: true };
                }
                return item;
              }
            ),
          }
        : employerDiscretionarySource,
    };

    dispatch(
      setManagePlanLocalCache({
        model: "sources",
        data: updatedSourceFormValues,
      })
    );
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
        pathParam: [FLOW_TYPES.SAVE, planId, sourceId],
      })
    );
    dispatch(
      setManagePlanToastInfo({
        showToast: true,
        toastMessage: "Data deleted successfully",
      })
    );
  };

  const buttons = [
    {
      onClick: goBack,
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      onClick: goBack,
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => setNewFlow(FLOW_TYPES.SAVE),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
  ];

  const getDataForSave = (values) => {
    const updatedValues = {
      ...formValues,
      ...values,
      [fields.availableEmployeeClassifications]: [
        ...transformToMultiselectSave(
          (values[fields.availableEmployeeClassifications] || []).filter(
            (val) =>
              !get(formValues, fields.availableEmployeeClassifications, [])
                .map((_) => _.employeeClassificationCodeId)
                .includes(val)
          ),
          "employeeClassificationCodeId"
        ),
        ...synchronizeCollection(
          get(formValues, fields.availableEmployeeClassifications, []),
          values[fields.availableEmployeeClassifications],
          "employeeClassificationCodeId"
        ),
      ],
    };
    let transformedData = {};
    if (isEmpty(formValues)) {
      if (isEmployerMatch) {
        transformedData = {
          ...sourcesListData.employerMatchSource,
          additionalMatchSources: [
            ...additionalAllocationRulesData,
            updatedValues,
          ],
        };
        return { ...sourcesListData, employerMatchSource: transformedData };
      }
      if (isEmployerDiscretionary) {
        transformedData = {
          ...sourcesListData.employerDiscretionarySource,
          additionalDiscretionarySources: [
            ...additionalAllocationRulesData,
            updatedValues,
          ],
        };
        return {
          ...sourcesListData,
          employerDiscretionarySource: transformedData,
        };
      }
      if (isDeferral) {
        transformedData = {
          ...sourcesListData.employeeDeferralSource,
          additionalDeferralSource: [
            ...additionalAllocationRulesData,
            updatedValues,
          ],
        };
        return { ...sourcesListData, employeeDeferralSource: transformedData };
      }
    }

    if (isDeferral) {
      transformedData = {
        ...sourcesListData.employeeDeferralSource,
        additionalDeferralSource: additionalAllocationRulesData.map(
          (addtionEligibilityItem, addtionEligibilityIndex) => {
            if (addtionEligibilityIndex === intRuleId) {
              return { ...addtionEligibilityItem, ...updatedValues };
            }
            return addtionEligibilityItem;
          }
        ),
      };
      return { ...sourcesListData, employeeDeferralSource: transformedData };
    }

    if (isEmployerMatch) {
      transformedData = {
        ...sourcesListData.employerMatchSource,
        additionalMatchSources: additionalAllocationRulesData.map(
          (addtionEligibilityItem, addtionEligibilityIndex) => {
            if (addtionEligibilityIndex === intRuleId) {
              return {
                ...addtionEligibilityItem,
                ...updatedValues,
                percentageOfCalculation: updatedValues.percentageOfCalculation,
              };
            }
            return addtionEligibilityItem;
          }
        ),
      };
      return { ...sourcesListData, employerMatchSource: transformedData };
    }

    if (isEmployerDiscretionary) {
      transformedData = {
        ...sourcesListData.employerDiscretionarySource,
        additionalDiscretionarySources: additionalAllocationRulesData.map(
          (addtionEligibilityItem, addtionEligibilityIndex) => {
            if (addtionEligibilityIndex === intRuleId) {
              return { ...addtionEligibilityItem, ...updatedValues };
            }
            return addtionEligibilityItem;
          }
        ),
      };
      return {
        ...sourcesListData,
        employerDiscretionarySource: transformedData,
      };
    }
  };
  const onFormSubmit = (values) => {
    const { history } = props;
    values.firstTierMatchPercent =
      values.isSafeHarbourMatch && values.safeHarbourType !== 3
        ? 100
        : parseInt(values.firstTierMatchPercent, 10);
    values.firstTierCompensationMatchPercent =
      values.isSafeHarbourMatch && values.safeHarbourType !== 3
        ? values.safeHarbourType === 1
          ? 3
          : 1
        : parseInt(values.firstTierCompensationMatchPercent, 10);
    values.secondTierMatchPercent =
      values.isSafeHarbourMatch && values.safeHarbourType !== 3
        ? 50
        : parseInt(values.secondTierMatchPercent, 10);
    values.secondTierCompensationMatchPercent =
      values.isSafeHarbourMatch && values.safeHarbourType !== 3
        ? values.safeHarbourType === 1
          ? 2
          : 5
        : parseInt(values.secondTierCompensationMatchPercent, 10);
    values.thirdTierMatchPercent = values.isSafeHarbourMatch
      ? 0
      : parseInt(values.thirdTierMatchPercent, 10);
    values.thirdTierCompensationMatchPercent = values.isSafeHarbourMatch
      ? 0
      : parseInt(values.thirdTierCompensationMatchPercent, 10);
    dispatch(
      setManagePlanLocalCache({
        model: "sources",
        data: getDataForSave(values),
      })
    );
    history.push(
      getPathWithParam({
        path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
        pathParam: [
          flow == FLOW_TYPES.ADD ? FLOW_TYPES.ADD : FLOW_TYPES.SAVE,
          planId,
          intSourceId,
        ],
      })
    );
    dispatch(
      setManagePlanToastInfo({
        showToast: true,
        toastMessage: "Data saved successfully",
      })
    );
  };

  const isEdit = newFlow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  console.log("formValues", formValues);
  return (
    <Formik
      initialValues={{
        ...formValues,
        [fields.allocationFormulaAppliesTo]: 1,
        [fields.availableEmployeeClassifications]: get(
          formValues,
          fields.availableEmployeeClassifications,
          []
        )?.map((val) => val.employeeClassificationCodeId),
        [fields.percentageOfCalculation]: get(
          formValues,
          "percentageOfCalculation"
        ),
        [fields.isLastDayRuleApplicable]: isEmployerMatch
          ? get(employerMatchSource, "isLastDayRuleApplicable", false)
          : false,
        [fields.isCatchApplicable]: get(formValues, "isCatchApplicable", false),
      }}
      onSubmit={onFormSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const { handleSubmit } = formProps;
        const sourceType = get(sourcesFormValues, "sourceType", "");
        const sourceCategory = get(sourcesFormValues, "sourceCategory", "");

        const isEmployee = parseInt(sourceType, 10) !== 2;
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={formProps.submitCount > 0}
          >
            <ManagePlanLayout buttons={buttons} pageFlow={newFlow || flow}>
              <div className="plan-heading">Allocation Rules</div>
              {isEmployee === true && (
                <EmployeeAdditionalAllocationRulesForm
                  {...formProps}
                  fields={fields}
                  isEdit={isEdit}
                  isSave={isSave}
                  planId={planId}
                />
              )}
              {isEmployee === false && (
                <EmployerAdditionalAllocationRulesForm
                  {...formProps}
                  fields={fields}
                  isEdit={isEdit}
                  isSave={isSave}
                  planId={planId}
                  sourceCategory={sourceCategory}
                />
              )}
            </ManagePlanLayout>
            <DeleteWarning
              DeleteToastMessageHead={DeleteToastMessageHead}
              DeleteToastMessage={DeleteToastMessage}
              showModal={showWarning}
              handleConfirmClick={handleConfirmClick}
              handleCancelClick={handleCancelClick}
            />

            <Modal show={showPopup} onHide={handleClose}>
              <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                <div className="text-right">
                  <FontAwesomeIcon
                    icon={faTimes}
                    color="#000"
                    onClick={handleClose}
                  />
                </div>
                <div className="d-flex">
                  <div className="pd-15">
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      color="#f94f50"
                      size="3x"
                    />
                  </div>
                  <div className="remove-text">
                    <p>{errorMessage}</p>
                    <br />

                    <Button
                      className="cancel-btn"
                      onClick={() => {
                        history.push(
                          getPathWithParam({
                            path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
                            pathParam: [FLOW_TYPES.EDIT, planId, sourceId],
                          })
                        );
                      }}
                    >
                      Ok
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SourcesAdditonalAllocationRulesContainer;
